"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const moment_1 = __importDefault(require("moment"));
class Sample {
    constructor(raw, parcel = null) {
        this.parcel = null;
        this.location = null;
        this.id = raw.id;
        this.code = raw.code;
        this.name = raw.name;
        this.parcel = parcel;
        this.becrop_report = raw.becrop_report;
        this.becrop_report_shi = raw.becrop_report_shi;
        this.date = (0, moment_1.default)(raw.date).toDate();
        if (raw.has_raw_ranks) {
            this.has_raw_ranks = raw.has_raw_ranks;
        }
        if (raw.location) {
            this.location = raw.location;
        }
    }
    get day_month() {
        if (this.date) {
            return (0, moment_1.default)(this.date).format('DDMMM').replace('.', '').toString();
        }
        else
            return '-';
    }
    get year() {
        if (this.date) {
            return (0, moment_1.default)(this.date).format('YYYY').replace('.', '').toString();
        }
        else
            return '-';
    }
}
exports.default = Sample;
